import api from "../../../api";

export const getSocietes = async () => {
  try {
    const response = await api.get("/societes");
    return response.data;
  } catch (err) {
    console.error("Erreur lors de la récupération des sociétés :", err);
    throw err;
  }
};

export const getSocieteById = async (id) => {
  try {
    const response = await api.get(`/societes/${id}`);
    return response.data;
  } catch (err) {
    console.error(`Erreur lors de la récupération de la société ${id} :`, err);
    throw err;
  }
};

export const createSociete = async (data) => {
  try {
    const response = await api.post("/societes", data);
    return response.data;
  } catch (err) {
    console.error("Erreur lors de la création de la société :", err);
    throw err;
  }
};

export const updateSociete = async (id, data) => {
  try {
    const response = await api.put(`/societes/${id}`, data);
    return response.data;
  } catch (err) {
    console.error(`Erreur lors de la mise à jour de la société ${id} :`, err);
    throw err;
  }
};

export const deleteSociete = async (id) => {
  try {
    const response = await api.delete(`/societes/${id}`);
    return response.data;
  } catch (err) {
    console.error(`Erreur lors de la suppression de la société ${id} :`, err);
    throw err;
  }
};